<template>
    <div id="topbar" class="borderBottom">
        <div class="toggleMenu" v-if="authToken.length && ($route.name !== 'HomePage')" :class="$router.history._startLocation.includes('login') ? 'open' : ''">
            <span></span>
            <span></span>
            <span></span>
        </div>

        <a @click="toggleDiv('.navLinks', false, false)"><div class="mobileMenu"><span></span><span></span><span></span></div></a>

        <router-link v-if="authToken.length" class="logo" to="/manage" title="PostgresqlCO.NF">Postgresql<strong>CO.NF</strong></router-link>
        <router-link v-else class="logo" to="/" title="PostgresqlCO.NF">Postgresql<strong>CO.NF</strong></router-link>

        <div class="navLinks">
            <a v-if="authToken.length && ($route.name != 'HomePage')" href="/doc/en" target="_blank" title="Documentation">Documentation</a>
            <router-link :to="'/tuning-guide'" title="Tuning Guide">Tuning Guide</router-link>
            <router-link :to="'/manage/apidocs'" title="Developers" v-if="$route.name != 'HomePage'">Developers</router-link>
            <div class="snippets">
                <a :href="confForBlogUrl" title="CO.NF for your Blog">CO.NF for your Blog</a>
                <div class="snippetMenu">
                    <router-link title="Configuration Snippet" to="/manage/snippet-usage">Configuration Snippet</router-link>
                    <a title="Parameter Snippet" href="/doc/snippet-usage/">Parameter Snippet</a>
                </div>
            </div>
        </div>
        <div class="navIcons">
            <!--<a v-if="authToken.length" title="Help">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g transform="translate(-1747 -23)"><circle cx="12.5" cy="12.5" r="12.5" transform="translate(1747 23)" fill="#d3d3d6" opacity="0"/><g transform="translate(-5.25 -21.75)"><path d="M-.606-4.354a.591.591,0,0,1-.475-.2.842.842,0,0,1-.17-.563,1.833,1.833,0,0,1,.211-.921,3.851,3.851,0,0,1,.586-.757,3.839,3.839,0,0,0,.4-.5.853.853,0,0,0,.135-.469A.5.5,0,0,0-.1-8.178.8.8,0,0,0-.618-8.33a1.5,1.5,0,0,0-.534.1,4.234,4.234,0,0,0-.592.287l-.281.141a1.433,1.433,0,0,1-.645.223.622.622,0,0,1-.5-.252.944.944,0,0,1-.205-.616.862.862,0,0,1,.088-.411A1.017,1.017,0,0,1-3-9.175a4.181,4.181,0,0,1,1.2-.6A4.4,4.4,0,0,1-.442-10a3.339,3.339,0,0,1,1.361.264A2.269,2.269,0,0,1,1.857-9a1.729,1.729,0,0,1,.34,1.05,1.758,1.758,0,0,1-.182.8,2.367,2.367,0,0,1-.44.622q-.258.258-.669.622a5.475,5.475,0,0,0-.592.545,1.094,1.094,0,0,0-.264.475.624.624,0,0,1-.229.4A.679.679,0,0,1-.606-4.354Zm.023,2.8a1.08,1.08,0,0,1-.8-.328,1.11,1.11,0,0,1-.323-.809A1.11,1.11,0,0,1-1.386-3.5a1.08,1.08,0,0,1,.8-.328A1.1,1.1,0,0,1,.233-3.5a1.11,1.11,0,0,1,.323.809,1.11,1.11,0,0,1-.323.809A1.1,1.1,0,0,1-.583-1.551Z" transform="translate(1765.274 62.996)" fill="#7a7b85"/><path d="M76.65-30a8.25,8.25,0,0,0-8.25,8.25,8.25,8.25,0,0,0,8.25,8.25,8.25,8.25,0,0,0,8.25-8.25A8.25,8.25,0,0,0,76.65-30Zm0,14.862a6.619,6.619,0,0,1-6.612-6.612,6.619,6.619,0,0,1,6.612-6.612,6.619,6.619,0,0,1,6.612,6.612A6.619,6.619,0,0,1,76.65-15.138Z" transform="translate(1688.1 79)" fill="#7a7b85"/></g></g></svg>
            </a>-->
            <a @click="toggleDarkmode()" id="darkmode" title="Switch Darkmode">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g transform="translate(-1775 -23)"><circle cx="12.5" cy="12.5" r="12.5" transform="translate(1775 23)" fill="#d3d3d6" opacity="0"/><g transform="translate(864.9 -602.1)"><rect width="2.106" height="2.106" rx="1" transform="translate(923.678 628.5) rotate(90)" fill="#7a7b85"/><rect width="2.106" height="2.106" rx="1" transform="translate(923.678 644.644) rotate(90)" fill="#7a7b85"/><rect width="2.106" height="2.106" rx="1" transform="translate(931.75 638.678) rotate(180)" fill="#7a7b85"/><rect width="2.106" height="2.106" rx="1" transform="translate(915.605 638.678) rotate(180)" fill="#7a7b85"/><path d="M99.615,156a5.615,5.615,0,1,0,5.615,5.615A5.615,5.615,0,0,0,99.615,156Zm-3.745,5.615a3.751,3.751,0,0,1,3.745-3.745v7.491A3.751,3.751,0,0,1,95.87,161.615Z" transform="translate(823.009 476.01)" fill="#7a7b85"/><rect width="2.106" height="2.106" rx="1" transform="translate(916.916 630.428) rotate(45)" fill="#7a7b85"/><rect width="2.106" height="2.106" rx="1" transform="translate(928.334 641.844) rotate(45)" fill="#7a7b85"/><rect width="2.106" height="2.106" rx="1" transform="translate(929.823 631.917) rotate(135)" fill="#7a7b85"/><rect width="2.106" height="2.106" rx="1" transform="translate(918.407 643.333) rotate(135)" fill="#7a7b85"/></g></g></svg>
            </a>
            <a v-if="authToken.length" @click="toggleDiv('#notificationsBar', false, false)" id="notifications" title="Notifications">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g transform="translate(-1813 -23)"><circle cx="12.5" cy="12.5" r="12.5" transform="translate(1813 23)" fill="#d3d3d6" opacity="0"/><g transform="translate(867.6 -602.5)"><path d="M14362.775,6294.852c0-.044,0-.089,0-.133h-3.647a1.172,1.172,0,0,1-.682-.22,1.089,1.089,0,0,1-.439-.722,1.043,1.043,0,0,1,.22-.8,5.18,5.18,0,0,1,.415-.455c.635-.638,1.421-1.432,1.421-4.3,0-4.581,2.481-5.637,3.545-5.879l.019,0,0,0v-.054a1.317,1.317,0,0,1,2.633,0v.058h.007l.019.007c1.063.238,3.542,1.295,3.542,5.879,0,2.871.789,3.665,1.425,4.3l.011.007a5.8,5.8,0,0,1,.4.44l0,0a1.035,1.035,0,0,1,.224.624,1.05,1.05,0,0,1-.31.775,1.163,1.163,0,0,1-.794.343h-3.812c0,.044,0,.089,0,.133a2.1,2.1,0,1,1-4.209,0Z" transform="translate(-13407 -5651.002)" fill="#7a7b85" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/></g></g></svg>
            </a>
            <a v-if="authToken.length" class="account" title="Account Settings" @click="toggleDiv('#accountSettings', false, false)">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g transform="translate(-1848 -23)"><circle cx="12.5" cy="12.5" r="12.5" transform="translate(1848 23)" fill="#d3d3d6" opacity="0"/><g transform="translate(867.532 -603)"><path d="M0,2.683A8.113,8.113,0,0,1,3.171,0,7.1,7.1,0,0,0,7.419,1.41,7.093,7.093,0,0,0,11.663,0a8.315,8.315,0,0,1,3.158,2.709,8.665,8.665,0,0,1-7.4,4.116A8.664,8.664,0,0,1,0,2.683Z" transform="translate(985.568 639.924)" fill="#7a7b85"/><ellipse cx="4.755" cy="4.643" rx="4.755" ry="4.643" transform="translate(988.198 630.25)" fill="#7a7b85"/></g></g></svg>
            </a>
        </div>

        <div id="notify" class="hideOnClick">
            <h2>NOTIFICATION</h2>
            <a @click="toggleDiv('#notify')" class="textBtn close" title="Close">Close</a>
            <div class="info"></div>
        </div>

        <div id="notificationsBar" class="borderLeft">
            <h2>Notifications</h2>
            <a @click="toggleDiv('#notificationsBar', false, false)" class="textBtn close" title="Close">Close</a>
            <ul>
                <li class="noResults">There are no notifications yet.</li>
            </ul>
        </div>

        <div id="accountSettings" class="borderLeft">
            <h2>Account Settings</h2>
            <a @click="toggleDiv('#accountSettings', false, false)" class="textBtn close" title="Close">Close</a>
            <ul>
                <li><a @click="logout" id="logOut" class="logOut" title="Log Out">Log Out</a></li>
            </ul>
        </div>
        <div id="loader"></div>
    </div>
</template>

<script>
import store from '../store'
import router from '../router'
import axios from 'axios'
import { mixin } from './mixins/mixin'

export default {
    name: 'TopBar',

    data: function() {
        return {

        }
    },

    mixins: [mixin],

    mounted: function() {
        const vc = this;

        // Intercept axios 401 responses
        axios.interceptors.response.use(function (response) {
            return response;
        },  function (error) {
            if (400 === error.response.status && !$('#infoBox').hasClass('show') && !vc.$route.name.includes()) {// Unknown response

                if(vc.$route.name != 'PublicTuningGuide')
                    vc.popUp('Error','There was an error when trying to process your request,<br/>please refresh the page and try again');
                
                return Promise.reject(error)
            }
            else if (401 === error.response.status && !$('#infoBox').hasClass('show') && store.state.authToken.length) { // Auth error
                vc.popUp('Session Expired','Your session has expired,<br><a href="' + vc.loginUrl +'" title="Login">click here</a> to login back to your dashboard');
            }
            else if (409 === error.response.status && !$('#infoBox').hasClass('show')) { // Duplicate error
                vc.popUp('Conflict Error','Your request could not be processed because of a naming conflict.<br/>Please review your input and try again');
                $('#loader').fadeOut()
            }
            else if ( 404 === error.response.status && !$('#infoBox').hasClass('show') && vc.$route.params.hasOwnProperty('id') ) { // Unknown config requested
                vc.popUp('Unknown Request','The requested resource could not be found,<br/>please make sure the requested configuration exists and try again');
                router.push('/manage')
            }
            else if ( !error.response || (500 === error.response.status && !$('#infoBox').hasClass('show')) ) // Unknown error
                vc.popUp('Server Error','There was an error when trying to access your configurations,<br/>please refresh the page and try again');
            else
                return Promise.reject(error);

            $('#loader').fadeOut()
        });

    },

    computed: {
        authToken () {
            return store.state.authToken
        },
    },

    methods: {

        logout() {
            document.cookie = "authToken=; Path=/; SameSite=Lax;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            document.cookie = "refreshToken=; Path=/; SameSite=Lax;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            document.cookie = "refreshTokenExpire=; Path=/; SameSite=Lax;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            store.commit('setAuthToken', '')
            store.commit('setRefreshToken', '')
            $('#accountSettings, #app').removeClass('open')
            this.toggleDiv('#accountSettings', false, false)
            localStorage.clear();
            this.$router.push('/');
        },

        toggleDarkmode() {
            if(!$('body').hasClass('darkmode')) {
                document.cookie = 'darkmode=1; Path=/; SameSite=Lax; Expires=Fri, 31 Dec 9999 23:59:59 GM';
                $("body").addClass("darkmode");
                store.commit('setTheme','dark')
            } else {
                $("body").removeClass('darkmode');
                document.cookie = 'darkmode=0; Path=/; SameSite=Lax; Expires=Fri, 31 Dec 9999 23:59:59 GM';
                store.commit('setTheme','light')
            }
        }

    }
}
</script>